import { render } from "./FtpUpload.vue?vue&type=template&id=15ad9e7a&scoped=true"
import script from "./FtpUpload.vue?vue&type=script&lang=js"
export * from "./FtpUpload.vue?vue&type=script&lang=js"

import "./FtpUpload.vue?vue&type=style&index=0&id=15ad9e7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ad9e7a"]])

export default __exports__